/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-slider {
  display: block;
  outline: none !important;
  position: relative;
}
.ux-slider--slides-auto-height .ux-slider-slide {
  height: auto !important;
}
.ux-slider--slides-overflow-visible {
  max-width: 100%;
  overflow-x: hidden;
}
.ux-slider--slides-overflow-visible .ux-slider-slide {
  overflow: visible;
}
.ux-slider--slides-overflow-visible .ux-slider-container {
  overflow: visible;
}
.ux-slider__content-container {
  position: relative;
}
.ux-slider__inner-container {
  float: none !important;
}
.ux-slider__faded-side {
  cursor: pointer;
  height: 110%;
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  transition: opacity 0.5s ease;
  width: 80px;
  z-index: 98;
}
.ux-slider__faded-side--left {
  background: linear-gradient(to left, rgba(255, 255, 255, 0.02) 0, #fff 100%);
  left: 0;
}
.ux-slider__faded-side--right {
  background: linear-gradient(to right, rgba(255, 255, 255, 0.02) 0, #fff 100%);
  right: 0;
}
@media only screen and (width <= 568px) {
  .ux-slider__faded-side {
    display: none;
  }
}
.ux-slider[direction=vertical] .ux-slider-container,
.ux-slider[direction=vertical] .ux-slider__content-container,
.ux-slider[direction=vertical] .ux-slider__inner-container {
  height: 100%;
  max-height: 100%;
}

.ux-slider .ux-slider-button {
  background: #fff;
  border: 0;
  box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08);
  height: 60px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  z-index: 99;
}
.ux-slider .ux-slider-button ux-icon {
  font-size: 35px;
  height: 35px;
  transition: all 0.3s;
  width: 30px;
}
.ux-slider .ux-slider-button:hover {
  background: #fff !important;
}
.ux-slider .ux-slider-button:hover ux-icon {
  color: #bbd03a;
}

.ux-slider--faded-sides {
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
}
.ux-slider--faded-sides .ux-slider-container {
  overflow: visible;
}

.ux-slider--cards .ux-slider__content-container {
  overflow: hidden;
  padding: 0 20% 25px 30px;
}
@media (min-width: 568px) {
  .ux-slider--cards .ux-slider__content-container {
    padding: 0 calc(20% + 45px) 25px 85px;
  }
}
.ux-slider--cards .ux-slider-slide:not(.ux-slider-slide-next ~ .ux-slider-slide) {
  opacity: 0;
}
.ux-slider--cards .ux-slider-slide {
  background-color: #fff;
}
.ux-slider--cards .ux-slider-slide-next,
.ux-slider--cards .ux-slider-slide-active {
  opacity: 1 !important;
}
.ux-slider--cards .ux-slider-slide-next ~ .ux-slider-slide ~ .ux-slider-slide ~ .ux-slider-slide ~ .ux-slider-slide ~ .ux-slider-slide {
  opacity: 0 !important;
}
.ux-slider--cards .ux-slider-slide-prev {
  opacity: 0.3 !important;
  transition: all 0.3s !important;
}
.ux-slider--cards .ux-slider-button-prev {
  left: 20px;
}
.ux-slider--cards .ux-slider-button-next {
  right: 20px;
}

/**
 * Swiper 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */
:root {
  --swiper-theme-color: var(--ux-color-primary);
  /*
  --swiper-preloader-color: var(--swiper-theme-color);
  --swiper-wrapper-transition-timing-function: initial;
  */
}

.ux-slider-zoom:hover {
  background-color: #000 !important;
}

.ux-slider-container {
  list-style: none;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  padding: 0;
  position: relative;
  z-index: 1;
  display: block;
}

.ux-slider-container-vertical > .ux-slider-wrapper {
  flex-direction: column;
}

.ux-slider-wrapper {
  box-sizing: content-box;
  display: flex;
  height: 100%;
  position: relative;
  transition-property: transform;
  width: 100%;
  z-index: 1;
  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
}

.ux-slider-container-android .ux-slider-slide,
.ux-slider-wrapper {
  transform: translate3d(0, 0, 0);
}

.ux-slider-container-multirow > .ux-slider-wrapper {
  flex-wrap: wrap;
}

.ux-slider-container-multirow-column > .ux-slider-wrapper {
  flex-flow: column wrap;
}

.ux-slider-container-free-mode > .ux-slider-wrapper {
  margin: 0 auto;
  transition-timing-function: ease-out;
}

.ux-slider-container-pointer-events {
  touch-action: pan-y;
}

.ux-slider-container-pointer-events.ux-slider-container-vertical {
  touch-action: pan-x;
}

.ux-slider-slide {
  flex-shrink: 0;
  height: 100%;
  position: relative;
  transition-property: transform;
  width: 100%;
  display: block;
}

.ux-slider-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.ux-slider-container-autoheight,
.ux-slider-container-autoheight .ux-slider-slide {
  height: auto;
}

.ux-slider-container-autoheight .ux-slider-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.ux-slider-container-backface-hidden .ux-slider-slide {
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/* 3D Effects */
.ux-slider-container-3d,
.ux-slider-container-3d.ux-slider-container-css-mode .ux-slider-wrapper {
  perspective: 1200px;
}

.ux-slider-container-3d .ux-slider-wrapper,
.ux-slider-container-3d .ux-slider-slide,
.ux-slider-container-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}

.ux-slider-container-3d .ux-slider-slide-shadow-left,
.ux-slider-container-3d .ux-slider-slide-shadow-right,
.ux-slider-container-3d .ux-slider-slide-shadow-top,
.ux-slider-container-3d .ux-slider-slide-shadow-bottom {
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
}

.ux-slider-container-3d .ux-slider-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.ux-slider-container-3d .ux-slider-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.ux-slider-container-3d .ux-slider-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

.ux-slider-container-3d .ux-slider-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.ux-slider-container-css-mode > .ux-slider-wrapper {
  overflow: auto;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.ux-slider-container-css-mode > .ux-slider-wrapper::-webkit-scrollbar {
  display: none;
}

.ux-slider-container-css-mode > .ux-slider-wrapper > .ux-slider-slide {
  scroll-snap-align: start start;
}

.ux-slider-container-horizontal.ux-slider-container-css-mode > .ux-slider-wrapper {
  scroll-snap-type: x mandatory;
}

.ux-slider-container-vertical.ux-slider-container-css-mode > .ux-slider-wrapper {
  scroll-snap-type: y mandatory;
}

:root {
  --swiper-navigation-size: 44px;
}

.ux-slider-button-prev,
.ux-slider-button-next {
  align-items: center;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
  cursor: pointer;
  display: flex;
  height: var(--swiper-navigation-size);
  justify-content: center;
  margin-top: calc(-1 * var(--swiper-navigation-size) / 2);
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  z-index: 10;
}
.ux-slider-button-prev:focus,
.ux-slider-button-next:focus {
  outline: none;
}

.ux-slider-button-prev.swiper-button-disabled,
.ux-slider-button-next.swiper-button-disabled {
  cursor: auto;
  opacity: 0.35;
  pointer-events: none;
}

/* .ux-slider-button-prev:after,
.ux-slider-button-next:after {
    font-family: swiper-icons;
    font-size: var(--swiper-navigation-size);
    text-transform: none !important;
    letter-spacing: 0;
    text-transform: none;
    font-variant: initial;
    line-height: 1;
} */
.ux-slider-button.ux-slider-button-prev ux-icon {
  margin-right: 10px;
}

.ux-slider-button-prev,
.ux-slider-container-rtl .ux-slider-button-next {
  left: 0;
  right: auto;
}

/* .ux-slider-button-prev:after,
.ux-slider-container-rtl .ux-slider-button-next:after {
    content: "prev";
} */
.ux-slider-button-next,
.ux-slider-container-rtl .ux-slider-button-prev {
  left: auto;
  right: 0;
}

/* .ux-slider-button-next:after,
.ux-slider-container-rtl .ux-slider-button-prev:after {
    content: "next";
} */
.ux-slider-button-prev.swiper-button-white,
.ux-slider-button-next.swiper-button-white {
  --swiper-navigation-color: #fff;
}

.ux-slider-button-prev.swiper-button-black,
.ux-slider-button-next.swiper-button-black {
  --swiper-navigation-color: #000;
}

.swiper-button-lock {
  display: none;
}

/* Scrollbar */
.swiper-scrollbar {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: relative;
  touch-action: none;
}

.ux-slider-container-horizontal > .swiper-scrollbar {
  bottom: 3px;
  height: 5px;
  left: 1%;
  position: absolute;
  width: 98%;
  z-index: 50;
}

.ux-slider-container-vertical > .swiper-scrollbar {
  height: 98%;
  position: absolute;
  right: 3px;
  top: 1%;
  width: 5px;
  z-index: 50;
}

.swiper-scrollbar-drag {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  height: 100%;
  left: 0;
  position: relative;
  top: 0;
  width: 100%;
}

.swiper-scrollbar-cursor-drag {
  cursor: move;
}

.swiper-scrollbar-lock {
  display: none;
}

.swiper-zoom-container {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.swiper-zoom-container > img,
.swiper-zoom-container > svg,
.swiper-zoom-container > canvas {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.ux-slider-slide-zoomed {
  cursor: move;
}

/* Preloader */
:root {
  /*
        --swiper-preloader-color: var(--swiper-theme-color);
        */
}

.swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  transform-origin: 50%;
  box-sizing: border-box;
  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
  border-radius: 50%;
  border-top-color: transparent;
}

.swiper-lazy-preloader-white {
  --swiper-preloader-color: #fff;
}

.swiper-lazy-preloader-black {
  --swiper-preloader-color: #000;
}

@keyframes swiper-preloader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* a11y */
.ux-slider-container .swiper-notification {
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  z-index: -1000;
}

.ux-slider-container-fade.ux-slider-container-free-mode .ux-slider-slide {
  transition-timing-function: ease-out;
}

.ux-slider-container-fade .ux-slider-slide {
  pointer-events: none;
  transition-property: opacity;
}

.ux-slider-container-fade .ux-slider-slide .ux-slider-slide {
  pointer-events: none;
}

.ux-slider-container-fade .ux-slider-slide-active,
.ux-slider-container-fade .ux-slider-slide-active .ux-slider-slide-active {
  pointer-events: auto;
}

.ux-slider-container-cube {
  overflow: visible;
}

.ux-slider-container-cube .ux-slider-slide {
  backface-visibility: hidden;
  height: 100%;
  pointer-events: none;
  transform-origin: 0 0;
  visibility: hidden;
  width: 100%;
  z-index: 1;
}

.ux-slider-container-cube .ux-slider-slide .ux-slider-slide {
  pointer-events: none;
}

.ux-slider-container-cube.ux-slider-container-rtl .ux-slider-slide {
  transform-origin: 100% 0;
}

.ux-slider-container-cube .ux-slider-slide-active,
.ux-slider-container-cube .ux-slider-slide-active .ux-slider-slide-active {
  pointer-events: auto;
}

.ux-slider-container-cube .ux-slider-slide-active,
.ux-slider-container-cube .ux-slider-slide-next,
.ux-slider-container-cube .ux-slider-slide-prev,
.ux-slider-container-cube .ux-slider-slide-next + .ux-slider-slide {
  pointer-events: auto;
  visibility: visible;
}

.ux-slider-container-cube .ux-slider-slide-shadow-top,
.ux-slider-container-cube .ux-slider-slide-shadow-bottom,
.ux-slider-container-cube .ux-slider-slide-shadow-left,
.ux-slider-container-cube .ux-slider-slide-shadow-right {
  backface-visibility: hidden;
  z-index: 0;
}

.ux-slider-container-cube .swiper-cube-shadow {
  bottom: 0;
  height: 100%;
  left: 0;
  opacity: 0.6;
  position: absolute;
  width: 100%;
  z-index: 0;
}

.ux-slider-container-cube .swiper-cube-shadow::before {
  background: #000;
  content: "";
  filter: blur(50px);
  inset: 0;
  position: absolute;
}

.ux-slider-container-flip {
  overflow: visible;
}

.ux-slider-container-flip .ux-slider-slide {
  backface-visibility: hidden;
  pointer-events: none;
  z-index: 1;
}

.ux-slider-container-flip .ux-slider-slide .ux-slider-slide {
  pointer-events: none;
}

.ux-slider-container-flip .ux-slider-slide-active,
.ux-slider-container-flip .ux-slider-slide-active .ux-slider-slide-active {
  pointer-events: auto;
}

.ux-slider-container-flip .ux-slider-slide-shadow-top,
.ux-slider-container-flip .ux-slider-slide-shadow-bottom,
.ux-slider-container-flip .ux-slider-slide-shadow-left,
.ux-slider-container-flip .ux-slider-slide-shadow-right {
  backface-visibility: hidden;
  z-index: 0;
}

.ux-slider--cards {
  overflow: visible;
}
.ux-slider--cards .ux-slider-slide {
  transform-origin: center bottom;
  backface-visibility: hidden;
}

.ux-slider-container-grid > .ux-slider-wrapper {
  flex-wrap: wrap;
}

.ux-slider-container-grid-column > .ux-slider-wrapper {
  flex-wrap: wrap;
  flex-direction: column;
}